module.exports = __webpack_public_path__ + "static/media/user-alien.06684421.svg";